import ContentLoader from "@components/renderLoader";
import Loading from "@components/loading/index";
import useLazy from "@src/static/hooks/useLazyComponent";

// 在android中，因为打开多个webview，useEffect不执行，使用useLayoutEffect替换即可
// 因为suspends React.lazy导致的useEffect不执行
// 初步判断是useEffect事件冲突
// 所以切换到自定义lazy组件
const LoadableComponent = (loader: any, { title = '纸条小卖部', type = 'loding' }: any) => {
    let layout: any = {
        'loader': ContentLoader,
        'loding': Loading
    }

    return useLazy({
        loader,
        loading() {
            return layout[type];
        },
        title: title
    });
};

const config: any = [
    {
        path: '/',
        component: LoadableComponent(() => import("../pages/homePage"), {
            title: '纸条小卖部',
            type: 'loader'
        })
    },
    {
        path: '/v1',
        component: LoadableComponent(() => import("../pages/homePage"), {
            title: '纸条小卖部',
            type: 'loader'
        })
    },
    {
        path: '/details',
        component: LoadableComponent(() => import("../pages/details"), {
            title: '商品详情'
        })
    },
    {
        path: '/pushOrder',
        component: LoadableComponent(() => import("../pages/pushOrder"), {
            title: '确认订单'
        })
    },
    {
        path: '/my/center',
        component: LoadableComponent(() => import("../pages/myCenter"), {
            title: '个人中心'
        })
    },
    {
        path: '/order/list',
        component: LoadableComponent(() => import("../pages/orderList"), {
            title: '订单列表'
        })
    },
    {
        path: '/order/details',
        component: LoadableComponent(() => import("../pages/orderDetails"), {
            title: '订单详情'
        })
    },
    {
        path: '/my/cart',
        component: LoadableComponent(() => import("../pages/cart"), {
            title: '购物车'
        })
    },
    {
        path: '/address/list',
        component: LoadableComponent(() => import("../pages/addressList"), {
            title: '地址列表'
        })
    },
    {
        path: '/address/add',
        component: LoadableComponent(() => import("../pages/addAddress"), {
            title: '收货地址'
        })
    },
    {
        path: '/choose/coupon',
        component: LoadableComponent(() => import("../pages/chooseCoupon"), {
            title: '选择优惠券'
        })
    },
    {
        path: '/my/couponDetails',
        component: LoadableComponent(() => import("../pages/couponDetails"), {
            title: '优惠券适用商品'
        })
    },
    {
        path: '/my/coupon',
        component: LoadableComponent(() => import("../pages/myCoupon"), {
            title: '我的优惠券'
        })
    },
    {
        path: '/exchange',
        component: LoadableComponent(() => import("../pages/exchange"), {
            title: '兑换方法'
        })
    },
    {
        path: '/pay/success',
        component: LoadableComponent(() => import("../pages/paySuccess"), {
            title: '支付'
        })
    },
    {
        path: '/order/refund',
        component: LoadableComponent(() => import("../pages/refund"), {
            title: '申请退款'
        })
    },
    {
        path: '/refund/process',
        component: LoadableComponent(() => import("../pages/refundProcess"), {
            title: '退款流程'
        })
    },
    {
        path: '/memberDetails',
        component: LoadableComponent(() => import("../pages/memberDetails"), {
            title: '满分礼盒（暖春陪伴版）'
        })
    },
    // {
    //     path: '/gk/details',
    //     component: LoadableComponent(() => import("../pages/gaokao"), {
    //         title: '高考作文押题课'
    //     })
    // },
    {
        path: '/activity/products',
        component: LoadableComponent(() => import("../pages/activityProducts"), {
            title: 'h5活动商品'
        })
    },
    {
        path: '/share/details',
        component: LoadableComponent(() => import("../pages/shareDetails"), {
            title: '商品详情'
        })
    },
    {
        path: '/share/member',
        component: LoadableComponent(() => import("../pages/shareMember"), {
            title: '满分礼盒（暖春陪伴版）'
        })
    },
    // {
    //     path: '/share/gaokao',
    //     component: LoadableComponent(() => import("../pages/shareGaokao"), {
    //         title: '高考作文押题课'
    //     })
    // },
    {
        path: '/share/activity/products',
        component: LoadableComponent(() => import("../pages/shareActivityProducts"), {
            title: 'h5活动商品'
        })
    },
    {
        path: '/share/team/details',
        component: LoadableComponent(() => import("../pages/shareTeam"), {
            title: '商品详情'
        })
    },
    {
        path: '/collection',
        component: LoadableComponent(() => import("../pages/collection"), {
            title: '商品合集'
        })
    },
    {
        path: '/graphic/details',
        component: LoadableComponent(() => import("../pages/graphicProduct"), {
            title: '图文商品'
        })
    },
    {
        path: '/activity/details',
        component: LoadableComponent(() => import("../pages/activityDetails"), {
            title: '活动商品'
        })
    },
    {
        path: '/team/details',
        component: LoadableComponent(() => import("../pages/teamDetails"), {
            title: '商品详情'
        })
    },
    {
        path: '/activity/detailsMember',
        component: LoadableComponent(() => import("../pages/activityDetailsMember"), {
            title: '必购精品'
        })
    },
    {
        path: '/share/activity/details',
        component: LoadableComponent(() => import("../pages/shareActivityDetails"), {
            title: '活动商品'
        })
    },
    {
        path: '/share/graphic',
        component: LoadableComponent(() => import("../pages/shareGraphic"), {
            title: '图文商品'
        })
    },
    {
        path: '/my/linkCoupon',
        component: LoadableComponent(() => import("../pages/linkCoupon"), {
            title: '链接优惠券详情页'
        })
    },
    {
        path: '/share/payMent',
        component: LoadableComponent(() => import("../pages/paymentOrder"), {
            title: '代付订单'
        })
    },
    {
        path: '/help/pay',
        component: LoadableComponent(() => import("../pages/helpPay"), {
            title: '找人帮我付'
        })
    },
    {
        path: '/combined/details',
        component: LoadableComponent(() => import("../pages/combinedDetail"), {
            title: '组合优惠购商品'
        })
    },
    {
        path: '/share/combined/details',
        component: LoadableComponent(() => import("../pages/shareCombinedDetail"), {
            title: '组合优惠购商品'
        })
    },
    {
        path: '/combined/display',
        component: LoadableComponent(() => import("../pages/combinedDisplay"), {
            title: '商品橱窗' // 组合展示页
        })
    },
]

export default config;